import React from 'react';
import T from 'prop-types';
import classnames from 'classnames';

const List = (props) => {
  const { children, isBorderless, isPaddingless, className } = props;
  return (
    <div
      className={classnames('List', {
        'is-borderless': isBorderless,
        'is-paddingless': isPaddingless,
        [className]: className,
      })}
    >
      <table>{children}</table>
    </div>
  );
};

const Item = ({
  description,
  value,
  isHighlighted,
  isSecondaryHighlight,
  isValueSecondaryHighlight,
  isColonAppended,
  className,
  midText = null,
}) => {
  return (
    <tr
      className={classnames({
        'is-highlighted': isHighlighted,
        'secondary-highlight': isSecondaryHighlight,
        'secondary-highlight-value': isValueSecondaryHighlight,
        'is-colon-appended': isColonAppended,
        [className]: className,
      })}
    >
      <td
        className={classnames('description', { [className]: className, ['width-50']: midText })}
      >
        {description}
      </td>
      {midText ? (
        <td className='width-30'
        >
          {midText}
        </td>
      ) : null}
      <td
        className={classnames('value', { [className]: className })}
      >
        {value}
      </td>
    </tr>
  );
};

Item.propTypes = {
  description: T.oneOfType([T.string, T.node]),
  value: T.any,
  isHighlighted: T.bool,
  isSecondaryHighlight: T.bool,
  isValueSecondaryHighlight: T.bool,
  isColonAppended: T.bool,
  className: T.string,
  midText: T.node,
};

List.Item = Item;

export default List;
